import React, { useEffect, useState } from 'react';
import { Grid, Skeleton, Alert, Link } from '@mui/material';
import Chart from 'react-apexcharts';
import axios from 'src/utils/axios';
import { useTheme } from '@mui/material/styles';

const ServiceNPS = ({ ServiceShopId, EmployeeRole }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const theme = useTheme();

    useEffect(() => {
        axios.get(`GetServiceNPS/${ServiceShopId}`).then((response) => {
            if (response) {
                setData(Array.isArray(response.data) ? response.data : []);
            }
            setLoading(false);
        });
    }, [ServiceShopId]);

    const ServiceNPSData = {
        series: [
            {
                name: 'NPS',
                data: data.map((item) => item.NPS),
                type: 'column'
            }
        ],
        options: {
            chart: {
                type: 'bar',
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                }
            },
            xaxis: {
                categories: data.map((item) => [`01 Ocak ${item.YEAR}`, '-', `${item.DATE}`]),
            },
            yaxis: {
                title: {
                    text: 'NPS Puanı'
                }
            },
            title: {
                text: 'Yıllık NPS Puanları'
            },
            colors: ['#008FFB'], // Sütun rengi
        }
    };

    const serviceNpsIncrease = (((ServiceNPSData.series[0].data[1] - ServiceNPSData.series[0].data[0]) / ServiceNPSData.series[0].data[0]) * 100).toFixed(1);
    const isPositive = serviceNpsIncrease >= 0;
    const chartTitle = isPositive ? 'Artış Oranı' : 'Azalış Oranı';
    const chartColor = isPositive ? '#2e7d32' : '#d32f2f';

    const ServiceNPSPercentageData = {
        series: [Math.abs(serviceNpsIncrease)],
        chart: {
            height: 350,
            type: 'radialBar',
            offsetY: -10
        },
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 135,
                dataLabels: {
                    name: {
                        fontSize: '16px',
                        color: chartColor,
                        offsetY: 76
                    },
                    value: {
                        offsetY: 92,
                        fontSize: '22px',
                        formatter: function (val) {
                            return val + "%";
                        }
                    }
                }
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                shadeIntensity: 0.15,
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 50, 65, 91]
            },
        },
        stroke: {
            dashArray: 4
        },
        //labels isPositive ? ['Artış Oranı'] : ['Azalış Oranı'],
        labels: [chartTitle],
        colors: [chartColor],
    };

    return (
        <div>
            <Grid container spacing={1}>
                <Grid size={8}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={350} width={'100%'} />
                    ) : (
                        <Chart
                            options={ServiceNPSData.options}
                            series={ServiceNPSData.series}
                            type="bar"
                            height={350}
                        />
                    )}
                </Grid>
                <Grid
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    size={4}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={280} width={'100%'} />
                    ) : (
                        <Chart
                            options={ServiceNPSPercentageData}
                            series={ServiceNPSPercentageData.series}
                            type="radialBar"
                            height={280}
                        />
                    )}
                </Grid>
                <Grid size={12}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={100} />
                    ) : (
                        (EmployeeRole === 1 || EmployeeRole === 2) && (
                            <Alert
                                variant="outlined"
                                severity="info"
                                sx={{
                                    borderColor: theme.palette.info.dark,
                                    fontSize: '12px',
                                    fontFamily: 'Helvetica, Arial, sans-serif'
                                }}>
                                Detaylı kırılımlarda görüntülemek için Atlas dashboardlardan faydalanabilirsiniz.
                                <br />
                                <Link
                                    href="https://atlas.beko.com/okta/sense/app/c35373ab-87b9-43c4-8f01-5aa7ec94c060/sheet/06b0edc0-864a-42f0-8722-ab6c94e26d60/state/analysis"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    İlgili Atlas dashboardundan faydalanmak için tıklayınız.
                                </Link>
                            </Alert>
                        )
                    )}
                </Grid>
            </Grid>
        </div>
    );
};

export default ServiceNPS;
